import Component from '@cell/cell-core/component/component';
import './image-slider.scss';

class ImageSlider extends Component {
  constructor() {
    super();

    this.elements = {
      scrollContainer: this.querySelector('.ImageSlider__ScrollContainer'),
      slides: this.querySelectorAll('.ImageSlider__ScrollContainer > *'),
      navigationButtons: this.querySelectorAll('.ImageSlider__NavigationButton'),
      bullets: this.querySelectorAll('.ImageSlider__Bullet'),
    };

    this.currentSlideIndex = 0;

    this.threshold = 50;

    this.scrollContainerLeft = this.elements.scrollContainer.getBoundingClientRect().left;
    this.scrollContainerRight = this.elements.scrollContainer.getBoundingClientRect().right;
  }

  componentDidMount() {
    this.elements.scrollContainer.on('scroll', this.handleScroll.bind(this));

    this.elements.navigationButtons.forEach((navigationButton, index) => {
      navigationButton.addEventListener('click', () => {
        this.scrollToSlide(index);
      });
    });

    this.on('c-button.click.prev', this.handleClickPrev.bind(this));
    this.on('c-button.click.next', this.handleClickNext.bind(this));

    globalThis.on('resize', this.handleWindowResize.bind(this));
  }

  handleWindowResize() {
    this.scrollContainerLeft = this.elements.scrollContainer.getBoundingClientRect().left;
    this.scrollContainerRight = this.elements.scrollContainer.getBoundingClientRect().right;
  }

  handleClickPrev() {
    const desiredIndex = Math.max(0, this.currentSlideIndex - 1);

    this.scrollToSlide(desiredIndex);
  }

  handleClickNext() {
    const desiredIndex = Math.min(this.elements.slides.length - 1, this.currentSlideIndex + 1);

    this.scrollToSlide(desiredIndex);
  }

  handleScroll() {
    this.elements.slides.forEach((slide, index) => {
      const slideLeft = slide.getBoundingClientRect().left;

      // If the left position of the slide is the same as the left side of the container this means
      // that the slide is fully visible and in "active" mode. Update the current slide index.
      if (
        slideLeft >= this.scrollContainerLeft - this.threshold &&
        slideLeft <= this.scrollContainerLeft + this.threshold
      ) {
        this.currentSlideIndex = index;

        this.setActiveBullet();
      }
    });

    // Determine if the user has reached the first or last slide and disable the buttons accordingly.

    // Check if the last slide's right side is visible in the viewport or we reached the end of the slides.
    const lastSlide = this.elements.slides[this.elements.slides.length - 1];
    const lastSlideRight = lastSlide.getBoundingClientRect().right;

    if (
      lastSlideRight <= this.scrollContainerRight + this.threshold ||
      this.currentSlideIndex === this.elements.slides.length - 1
    ) {
      this.nextButtons.forEach((button) => {
        button.disable();
      });
    } else {
      this.nextButtons.forEach((button) => {
        button.enable();
      });
    }

    // Check if the first slide's left side is visible in the viewport or we reached the beginning of the slides.
    const firstSlide = this.elements.slides[0];
    const firstSlideLeft = firstSlide.getBoundingClientRect().left;

    if (
      firstSlideLeft >= this.scrollContainerLeft - this.threshold ||
      this.currentSlideIndex === 0
    ) {
      this.previousButtons.forEach((button) => {
        button.disable();
      });
    } else {
      this.previousButtons.forEach((button) => {
        button.enable();
      });
    }
  }

  scrollToSlide(index) {
    if (index === this.currentSlideIndex) return;

    const assosiatedSlideElement = this.elements.slides[this.currentSlideIndex];

    let left = assosiatedSlideElement.getBoundingClientRect().width * index;

    this.elements.scrollContainer.scroll({ left, behaviour: 'smooth' });
  }

  setActiveBullet() {
    this.elements.bullets.forEach((bullet, bulletIndex) => {
      const isActive = bulletIndex === this.currentSlideIndex;

      bullet.classList.toggle('ImageSlider__Bullet--Active', isActive);
    });
  }

  get previousButtons() {
    return this.querySelectorAll('[data-action="prev"]');
  }

  get nextButtons() {
    return this.querySelectorAll('[data-action="next"]');
  }
}

customElements.define('image-slider', ImageSlider);
